import 'slick-carousel';

wp.domReady(() => {
  jQuery('.block--case-study-carousel .field-case-studies').slick(
    {
      fade: true, // Disables instant fade transition
      speed: 400,  // Adjust as needed
      cssEase: 'linear', // Ensures smooth transition
    }
  );
});
